@if (isModalOpen) {
  <app-modal title="Invite Vendor" (close)="closeModal()" [showFooter]="false">
    <form [formGroup]="inviteVendorFormGroup" (ngSubmit)="sendInvite()">
      <div class="space-y-4 p-4 w-full min-w-[500px]" id="modal-content">
        <!-- Company Name -->
        <div>
          <app-input-field
            type="text"
            label="Company Name"
            placeholder="Enter company name"
            [required]="true"
            formControlName="companyUserName"
          ></app-input-field>
          @if (
            inviteVendorFormGroup.get('companyUserName')?.invalid &&
            inviteVendorFormGroup.get('companyUserName')?.touched
            ) {
            <div
              class="mt-1 text-xs text-red-500"
              >
              @if (inviteVendorFormGroup.get('companyUserName')?.errors?.['required']) {
                <span
                  >Company name is required</span
                  >
                }
              </div>
            }
          </div>
          <!-- Contact Email -->
          <div>
            <app-input-field
              type="email"
              label="Email ID"
              placeholder="Enter email ID"
              [required]="true"
              formControlName="EmailId"
            ></app-input-field>
            @if (
              inviteVendorFormGroup.get('EmailId')?.invalid &&
              inviteVendorFormGroup.get('EmailId')?.touched
              ) {
              <div
                class="mt-1 text-xs text-red-500"
                >
                @if (inviteVendorFormGroup.get('EmailId')?.errors?.['required']) {
                  <span
                    >Email is required</span
                    >
                  }
                  @if (inviteVendorFormGroup.get('EmailId')?.errors?.['email']) {
                    <span
                      >Please enter a valid email</span
                      >
                    }
                  </div>
                }
              </div>
              <!-- Phone Number -->
              <div>
                <label
                  for="phoneNumber"
                  class="mb-2 block text-xs font-medium text-primary"
                  >Phone</label
                  >
                  <intl-phone-input
                    id="phoneNumber"
                    formControlName="phoneNumber"
                    [preferredCountries]="['IN', 'US', 'GB', 'CA', 'AU']"
                    (countryChange)="onCountryChange($event)"
                    [dialCode]="countryCode || '+91'"
                    [enableIPDetection]="false"
                    >
                  </intl-phone-input>
                  @if (
                    inviteVendorFormGroup.get('phoneNumber')?.invalid &&
                    inviteVendorFormGroup.get('phoneNumber')?.touched
                    ) {
                    <div
                      class="mt-1 text-xs text-red-500"
                      >
                      @if (inviteVendorFormGroup.get('phoneNumber')?.errors?.['required']) {
                        <span
                          >Phone number is required</span
                          >
                        }
                      </div>
                    }
                  </div>
                  <!-- Modal Actions -->
                  <div
                    class="mt-4 flex justify-end gap-3 border-t border-gray-200 pt-4 dark:border-gray-600"
                    >
                    <app-button-outline title="Cancel" type="button" (click)="closeModal()">
                    </app-button-outline>
                    <app-button-fill
                      title="Send Invitation"
                      type="submit"
                      [disabled]="inviteVendorFormGroup.invalid || isInviteLoading"
                      [loading]="isInviteLoading"
                      >
                    </app-button-fill>
                  </div>
                </div>
              </form>
            </app-modal>
          }

